// ── TonightPlansPage dismissed-suggestions sync (per-day) ───────────────────
// "Dismiss this show" on the Tonight page's suggestion list was localStorage-
// only, keyed per-day (nextep_tonight_dismissed_<today>) — clearing suggestions
// on the phone at breakfast left them reappearing on a tablet that evening
// (2026-08-21 audit). Same shape as checkinSnooze: only ever checked against
// TODAY, so the server side self-prunes (see mark_tonight_dismissed_rpc.sql)
// rather than accumulating every day's dismissals forever.
import { safeStorage } from './safeStorage'
import { supabase } from './supabase'

const KEY = (date) => `nextep_tonight_dismissed_${date}`

export function getTonightDismissed(date) {
  try { return new Set(JSON.parse(safeStorage.get(KEY(date)) || '[]')) } catch { return new Set() }
}

export function dismissTonight(date, showId) {
  const next = getTonightDismissed(date)
  next.add(showId)
  try { safeStorage.set(KEY(date), JSON.stringify([...next])) } catch { /* non-fatal */ }
  try { supabase.rpc('mark_tonight_dismissed', { p_date: date, p_show_id: String(showId) }).then(() => {}, () => {}) } catch { /* non-fatal */ }
  return next
}

export function resetTonightDismissed(date) {
  try { safeStorage.remove(KEY(date)) } catch { /* non-fatal */ }
  try { supabase.rpc('clear_tonight_dismissed', { p_date: date }).then(() => {}, () => {}) } catch { /* non-fatal */ }
}

// Called once when the profile loads (useAuth.jsx) — merges TODAY's server-side
// dismissed set into this device's localStorage. Only today matters (the RPC
// itself discards prior days), so there's nothing to sync for any other date.
export function syncTonightDismissedFromProfile(profile, today) {
  const remote = profile?.ui_prefs?.tonight_dismissed?.[today]
  if (!Array.isArray(remote) || !remote.length) return
  const local = getTonightDismissed(today)
  const merged = new Set([...local, ...remote])
  try { safeStorage.set(KEY(today), JSON.stringify([...merged])) } catch { /* non-fatal */ }
}
